var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manual-tools02-contents"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("ASPとアドタスカルを連携する(CATS)")])])],1),_c('el-row',[_c('el-col',[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("準備中")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }